<template>
  <div>
    <v-container class="transparent" fluid>
      <bread-crumb :breadcrumb-data="breadcrumbData"></bread-crumb>
      <v-sheet  class="pa-2 my-6" rounded outlined min-height="600">
        <stat-dual-summ class="pa-4" :data="statisticData"></stat-dual-summ>
      </v-sheet>
    </v-container>

  </div>
</template>

<script>
import BreadCrumb from "@/components/sub/breadcrumb.vue";
import StatSoucrePie from "@/unUsedComponents/StatSoucrePie.vue";
import StatSourceVenn from "@/unUsedComponents/StatSourceVenn.vue";
import Axios from "axios";
import HallmarkDonut from "@/components/HallmarkDonut.vue";
import StatDualSumm from "@/components/StatDualSumm.vue";
import { statisticdata } from '@/config/exampleList'

export default {
  name: "Statistics",
  props: [],
  components: {StatDualSumm, HallmarkDonut, StatSourceVenn, StatSoucrePie, BreadCrumb},
  data() {
    return {
      loading:false,
      local_data:{},

      images:{},

    }
  },
  methods: {

  },
  mounted() {

  },
  created() {

  },
  computed: {
    statisticData() {
      return statisticdata
    },
    breadcrumbData()
    {
      return [
        {text: "Home", disabled: false, to: "/"},
        {text: "Statistic", disabled: true}
      ];
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>

</style>